import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts from "react-highcharts";
import seriesColor from "../../../../utils/seriesColor";

import styles from "./styles.scss";
import { shouldUpdate } from "../../../../utils";
import ChartWithSyncedZoom from '../ChartWithSyncedZoom/ChartWithSyncedZoom';
import ToggleChartSeries from '../../../ToggleChartSeries/ToggleChartSeries';

let count = 0;
const idPrefix = "LineChart";

@CSSModules(styles, { allowMultiple: true })
class ColumnChart extends Component {
	constructor(props) {
		super(props);
		this.chart = React.createRef();
	}

	render() {
		const config = {
			chart: {
				animation: false,
				marginBottom: 85,
				zoomType: "x",
				panning: true,
				panKey: 'shift',
				style: {
					 fontFamily: "Helvetica",
				}
			},
			credits: {
				enabled: false
			},
			colors: seriesColor.getSeriesColors(),
			title: {
				text:  this.props.component.chartTitle || "Column Chart",
				align: "left",
				margin: 60,
				style: {
					color: "#4D4D4D",
					"font-size": "20px",
					"font-weight": "600"
				}
			},
			legend: {
				itemStyle: {
					 color: '#999',
					 fontWeight: 'normal',
					 fontSize: '14px',
				},
				align: "center",
				verticalAlign: "bottom",
				layout: "horizontal"
			},
			plotOptions: {
				column: {
					stacking: this.props.useStacking ? (this.props.usePercent ? "percent" : "normal") : undefined,
					pointPadding: this.props.useStacking ? 0 : 0,
					groupPadding: this.props.useStacking ? 0 : 0.1,
					pointWidth: this.props.useStacking ? null : undefined,
				},
			},
			xAxis: {
				type: "datetime",
				lineColor: "#e6e6e6"
			},
			yAxis: {
				stackLabels: {
					enabled: false,
					style: {
						fontWeight: "bold"
					}
				},
			},
			series: []
		};

		return (
            <div>
                <ReactHighcharts config={config} ref={this.chart} isPureConfig={true} />
                <ToggleChartSeries chart={this.chart} />
            </div>
        ) 
	}

	setup() {
		let chart = this.chart.current.getChart();
		if (chart) {
			this.props.loadData(this.props.component, chart, this.props.timePeriod, this.props.onLoadComplete);
			setTimeout(() => {
			   if(chart) {
				  chart.reflow();
				  chart.redraw();
			   }
			}, 100);
		}
	}

	teardown() {}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.setup();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (component, chart, timePeriod, onLoadComplete) => dispatch(actions.loadData(component, chart, timePeriod, onLoadComplete))
	};
};

const mapStateToProps = (state, ownProps) => ({});

export default connect(
	mapStateToProps,
	bindAction
)(ChartWithSyncedZoom(ColumnChart));



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ColumnChart/ColumnChart.js